import { M8PartnerDTO } from 'services/production/types';
import { getM8PartnerURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { customFetch } from 'utils/http';

export const me = async (): Promise<M8PartnerDTO> => {
  const fetchURL = getM8PartnerURL('me');

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
